/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { createContext, useContext, useState } from 'react';

// Language translations
const translations = {
  id: {
    // Navigation
    home: 'Beranda',
    about: 'Tentang Kami',
    products: 'Produk',
    blog: 'Blog',
    contact: 'Kontak Kami',
    
    // Common
    readMore: 'Baca Selengkapnya',
    getStarted: 'Mulai Sekarang',
    learnMore: 'Pelajari Lebih Lanjut',
    viewAll: 'Lihat Semua',
    loadMore: 'Muat Lebih Banyak',
    backToHome: 'Kembali ke Beranda',
    
    // Hero section
    heroTitle: 'Solusi Nutrisi Tanaman Terbaik untuk Petani Indonesia',
    heroSubtitle: 'Tingkatkan hasil panen dengan pupuk berkualitas tinggi dan ramah lingkungan yang telah dipercaya ribuan petani',
    heroButton: 'Cek Produk',
    
    // About section
    aboutTitle: 'Tentang Kami',
    aboutSubtitle: 'Tim ahli yang berdedikasi untuk kemajuan pertanian Indonesia',
    visionTitle: 'Visi Kami',
    visionText: 'Menjadi perusahaan terdepan dalam penyediaan solusi nutrisi tanaman yang berkelanjutan',
    missionTitle: 'Misi Kami',
    missionText: 'Memberikan produk berkualitas tinggi dan layanan terbaik untuk meningkatkan produktivitas pertanian',
    
    // Products section
    productsTitle: 'Produk Unggulan',
    productsSubtitle: 'Solusi nutrisi lengkap untuk berbagai jenis tanaman',
    productCategories: 'Kategori Produk',
    organicFertilizer: 'Pupuk Organik',
    liquidFertilizer: 'Pupuk Cair',
    granularFertilizer: 'Pupuk Granular',
    micronutrients: 'Mikronutrien',
    
    // Blog section
    blogTitle: 'Artikel & Tips Pertanian',
    blogSubtitle: 'Informasi terkini tentang teknik budidaya dan nutrisi tanaman',
    latestArticles: 'Artikel Terbaru',
    popularArticles: 'Artikel Populer',
    categories: 'Kategori',
    searchPlaceholder: 'Cari artikel...',
    publishedOn: 'Dipublikasikan pada',
    writtenBy: 'Ditulis oleh',
    
    // Testimonials
    testimonialTitle: 'Testimoni Petani',
    testimonialSubtitle: 'Kepuasan dan hasil nyata dari para petani yang telah menggunakan produk kami',
    
    // Contact section
    contactTitle: 'Hubungi Kami',
    contactSubtitle: 'Konsultasi gratis untuk kebutuhan nutrisi tanaman Anda',
    nameLabel: 'Nama Lengkap',
    emailLabel: 'Email',
    phoneLabel: 'Nomor Telepon',
    messageLabel: 'Pesan',
    sendMessage: 'Kirim Pesan',
    contactInfo: 'Informasi Kontak',
    address: 'Alamat',
    phone: 'Telepon',
    email: 'Email',
    
    // Footer
    footerDescription: 'Kami berkomitmen memberikan solusi nutrisi tanaman terbaik untuk meningkatkan produktivitas pertanian Indonesia',
    quickLinks: 'Tautan Cepat',
    followUs: 'Ikuti Kami',
    allRightsReserved: 'Semua hak dilindungi',
    
    // Service section
    servicesTitle: 'Layanan Kami',
    servicesSubtitle: 'Solusi lengkap untuk kebutuhan pertanian modern',
    consultation: 'Konsultasi Ahli',
    consultationDesc: 'Dapatkan saran dari ahli nutrisi tanaman berpengalaman',
    soilTesting: 'Uji Tanah',
    soilTestingDesc: 'Analisis kondisi tanah untuk rekomendasi pupuk yang tepat',
    customFormula: 'Formula Khusus',
    customFormulaDesc: 'Pupuk dengan formulasi khusus sesuai kebutuhan tanaman',
    
    // Advantages section
    advantagesTitle: 'Keunggulan Produk',
    advantagesSubtitle: 'Mengapa memilih produk kami',
    quality: 'Kualitas Terjamin',
    qualityDesc: 'Produk berkualitas tinggi dengan sertifikasi internasional',
    organic: 'Ramah Lingkungan',
    organicDesc: 'Formula organik yang aman untuk tanah dan lingkungan',
    effective: 'Hasil Optimal',
    effectiveDesc: 'Terbukti meningkatkan hasil panen hingga 40%',
    support: 'Dukungan Teknis',
    supportDesc: 'Tim ahli siap membantu aplikasi produk yang tepat',
    
    // Portfolio/Projects
    portfolioTitle: 'Proyek Sukses',
    portfolioSubtitle: 'Hasil nyata dari penerapan produk kami',
    projectDetail: 'Detail Proyek',
    location: 'Lokasi',
    cropType: 'Jenis Tanaman',
    area: 'Luas Area',
    result: 'Hasil',
    
    // Error pages
    pageNotFound: 'Halaman Tidak Ditemukan',
    pageNotFoundDesc: 'Maaf, halaman yang Anda cari tidak dapat ditemukan',
    backToHomepage: 'Kembali ke Beranda',
    
    // Portfolio/Product pages
    ourProducts: 'Produk Kami',
    productsDescription: 'Jelajahi produk pupuk dan nutrisi tanaman premium kami. Setiap produk diformulasikan secara khusus untuk memastikan pertumbuhan tanaman yang maksimal, tanah yang subur, dan hasil panen yang berlimpah. Dengan produk bersertifikasi dari kami, Anda selangkah lebih dekat menuju keberhasilan pertanian berkelanjutan.',
    fertilizer: 'Pupuk',
    plantNutrition: 'Nutrisi Tanaman',
    others: 'Lainnya',
    
    // Testimonials section
    testimonial: 'Testimoni',
    testimonialDesc: 'Apa yang klien katakan tentang pelayanan dan produk kami.',
    
    // Call to action section
    readyForBestHarvest: 'Siap panen terbaik tahun ini?',
    contactUs: 'Kontak Kami',
    achieveDreamHarvest: 'Mari kita wujudkan impian Anda untuk panen melimpah dan pertanian sukses!',
    
    // Blog CTA section
    needConsultation: 'Butuh Konsultasi?',
    consultationDescription: 'Tim ahli kami siap membantu Anda memilih pupuk terbaik untuk panen melimpah dan tanah subur.',
    contactUsButton: 'Hubungi Kami',
    viewAllProducts: 'Lihat Semua Produk',
    
    // Blog error messages
    articleNotFound: 'Artikel Tidak Ditemukan',
    articleNotFoundDesc: 'Maaf, artikel yang Anda cari tidak dapat ditemukan.',
    backToBlog: 'Kembali ke Blog',
    back: 'Kembali',
    
    // About/Team page
    aboutUsTitle: 'Tentang Kami',
    companyDescription: 'Bulindo Agro Teknologi adalah perusahaan yang bergerak di bidang teknologi pertanian, Bulindo Agro Teknologi dirancang untuk mengembangkan teknologi inovatif yang mampu menghadapi tantangan pertanian modern di tingkat global.',
    fertilizerDescription: 'Pupuk khusus kami mendukung seluruh umur tanaman dengan menyediakan semua nutrisi yang mereka butuhkan untuk tumbuh lebih sehat dan lebih kuat. Nutrisi tanaman yang efisien dikombinasikan dengan layanan teknis canggih memastikan tanaman yang diperkuat dan ketahanan yang lebih baik.',
    
    // Vision Mission
    visionMissionTitle: 'Visi & Misi',
    vision: 'Visi',
    mission: 'Misi',
    visionText2: 'Mewujudkan pertanian yang inovatif, berkelanjutan, dan berdaya saing global melalui penerapan teknologi cerdas untuk mendukung ketahanan pangan dan keseimbangan ekosistem dunia.',
    
    missionPoint1: 'Mengembangkan Teknologi Pertanian Cerdas',
    missionPoint1Desc: 'Bulindo Agro Teknologi berkomitmen untuk mengembangkan teknologi inovatif yang mampu menghadapi tantangan pertanian modern di tingkat global.',
    missionPoint2: 'Mendorong Praktik Pertanian Berkelanjutan',
    missionPoint2Desc: 'Menerapkan metode ramah lingkungan yang mengurangi dampak negatif terhadap tanah, air, dan udara. Menyediakan produk pupuk berkualitas tinggi yang ramah lingkungan dan mendukung kelestarian sumber daya alam.',
    missionPoint3: 'Mendukung Produktivitas Petani',
    missionPoint3Desc: 'Menghadirkan solusi pupuk inovatif yang mampu meningkatkan hasil panen dan efisiensi penggunaan sumber daya.',
    missionPoint4: 'Memberdayakan Petani dan Komunitas',
    missionPoint4Desc: 'Memberikan pelatihan dan edukasi kepada petani mengenai penggunaan pupuk yang efektif dan berkelanjutan untuk hasil maksimal.',
    missionPoint5: 'Membangun Kemitraan yang Kuat',
    missionPoint5Desc: 'Berkolaborasi dengan pemerintah, organisasi, dan pelaku industri untuk memperkuat rantai pasokan pupuk dan memperluas dampak positif bagi pertanian.',
    
    companyValues: 'Nilai-Nilai Perusahaan',
    innovation: 'Inovasi',
    innovationDesc: 'Terus berinovasi dalam teknologi pertanian',
    qualityDesc2: 'Mengutamakan kualitas produk terbaik',
    sustainability: 'Sustainability',
    sustainabilityDesc: 'Berkomitmen pada pertanian berkelanjutan',
    
    // Contact form
    contactFormSubtitle: 'Ayo mulai kerja sama untuk hasil tani yang lebih baik! Isi formulir di bawah, dan kami akan kembali menghubungi Anda dalam 24 jam.',
    yourName: 'Nama Anda',
    yourCompany: 'Perusahaan Anda',
    yourEmail: 'Email Anda',
    yourPhone: 'Nomor Telepon Anda',
    yourMessage: 'Tinggalkan pesan Anda di sini',
    send: 'Kirim',
    successMessage: 'Berhasil! Kami akan segera menghubungi Anda. Terima kasih!',
    errorMessage: 'Harap isi formulir yang kosong.',
    
    // Contact page
    viewOnMaps: 'Lihat di Maps',
    businessHours: 'Jam Operasional',
    mondayFriday: 'Senin - Jumat',
    saturday: 'Sabtu',
    sundayHolidays: 'Minggu & Hari Libur',
    closed: 'Tutup',
    contactNote: 'Kami siap melayani Anda dengan sepenuh hati. Hubungi kami untuk konsultasi gratis!',
    
    // Project detail page
    projectNotFound: 'Produk Tidak Ditemukan',
    goBack: 'Kembali',
    productDescription: 'Deskripsi Produk',
    productType: 'Jenis Produk',
    
    // Product descriptions
    turanDesc: 'Produk berbasis Teknologi EnNuvi, Polifenol, mengkomplekskan unsur-unsur hara untuk meningkatkan kinerjanya sehingga dapat melindungi tanaman dengan lebih baik dari segala jenis stress.',
    colossalKDesc: 'Kami dengan bangga memperkenalkan produk terbaru kami yang bernama Collosal-K, yaitu larutan kalium berkualitas tinggi yang dirancang khusus untuk digunakan sebagai pupuk. Produk ini sangat efektif dalam mencegah atau memperbaiki kekurangan kalium yang seringkali menjadi masalah pada berbagai jenis tanaman.',
    foliarelDesc: 'Untuk meningkatkan pembentukan dan kesuburan bunga melalui viabilitas serbuk sari yang lebih baik, meningkatkan pembentukan buah produktivitas yang tinggi.',
    mantusDesc: 'Mantus dengan teknologi EnNuVi, terobosan teknologi biostimulan sekaligus merupakan pupuk alami, bioaktivator, dan sumber makanan bagi tanaman.',
    nixiDesc: 'Nixi dengan teknologi Foliflo menciptakan suspensi yang diformulasikan dengan bioaktivasi dan nutrisi lengkap untuk melindungi ketahanan tanaman.',
    primerDesc: 'Formulasi baru yang dioptimalkan dan telah dipatenkan, mengandung Pico Technology yang berasal dari minyak esensial alami. Formulasi canggih ini membuat organisme target (misalnya serangga) menjadi sangat sensitif, sehingga aplikasi pestisida dengan dosis standar setelah penggunaan Pangaea Booster™ dapat membunuh hama yang paling resisten sekalipun dengan cara menonaktifkan jalur metabolisme (cytochrome P-450) di dalam tubuh serangga.',
    adesivorDesc: 'Adesivo Ini hanyalah teks contoh dari industri percetakan dan penataan huruf.',
    defaultProductDesc: 'Deskripsi produk akan segera tersedia. Hubungi tim kami untuk informasi lebih lanjut mengenai produk ini.',
    
    // Services content
    service1Title: 'Pupuk dan Nutrisi Tanaman Terbaik',
    service2Title: 'Konsultasi Pertanian',
    service3Title: 'Pemberdayaan Petani dan Komunitas',
    
    // Advantages content
    advantage1Title: 'Produk Berkualitas Tinggi',
    advantage1Desc: 'Kami menghadirkan produk pupuk berkualitas tinggi yang dirancang untuk meningkatkan hasil panen sekaligus menjaga keseimbangan ekosistem',
    advantage2Title: 'Harga Terjangkau',
    advantage2Desc: 'Berkomitmen untuk menyediakan produk dengan harga terjangkau sebagai solusi terbaik bagi para petani, agribisnis, dan masyarakat yang peduli terhadap masa depan pertanian Indonesia',
    advantage3Title: 'Produk Teruji​',
    advantage3Desc: 'Produk kami telah dirancang khusus untuk memenuhi kebutuhan berbagai jenis tanaman, dan sudah teruji kualitasnya.',
    advantage4Title: 'Favorit Para Petani',
    advantage4Desc: 'Para petani telah mencoba produk kami, dan semua klien kami sangat menyukainya.',
    
    // Testimonials content
    testimonial1Name: 'Dadang',
    testimonial1Company: 'Petani',
    testimonial1Text: 'Saya menanam padi dari awal umur satu minggu pakai produk NIXI. Dan, alhamdulillah bagus terus anakan juga banyak, daun juga bisa lebar, lalu ketinggian juga maksimal bisa tinggi. Baguslah istilahnya bagus dibanding dengan produk yang lain bisa menjamin ininya akas dan anakan juga banyak.',
    testimonial2Name: 'Amin',
    testimonial2Company: 'Petani',
    testimonial2Text: 'Saya sudah menggunakan mantus, saat aplikasi umur sepuluh hari dan umur dua puluh hari. untuk nixinya tiga kali boleh dilihat hasilnya. Alhamdulillah di daun untuk yang saya rasakan itu untuk mantusnya itu di daun bisa tebel, terus atas di daun akas daun bisa tebel, daunnya jadi tidak lemes ya.',
    testimonial3Name: 'Mamuri',
    testimonial3Company: 'Petani',
    testimonial3Text: 'Setelah saya pakai nixi dan mantus. Dari dinding sel itu kelihatan tebel-tebel tapi lentur. Jadi kalau kita mau siram apa gak khawatir daunnya tuh pada patah. kelebihan yang kedua itu biasanya kan kalau kita pakai nutrisi itu kan bisa membunuh pestisida yang lain. Nah, setelah saya coba pakai, biarpun saya langsung campur juga yang lainnya, semua itu mempan semua.',
  },
  en: {
    // Navigation
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    blog: 'Blog',
    contact: 'Contact Us',
    
    // Common
    readMore: 'Read More',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    viewAll: 'View All',
    loadMore: 'Load More',
    backToHome: 'Back to Home',
    
    // Hero section
    heroTitle: 'Best Plant Nutrition Solutions for Indonesian Farmers',
    heroSubtitle: 'Increase your harvest with high-quality and eco-friendly fertilizers trusted by thousands of farmers',
    heroButton: 'Explore Products',
    
    // About section
    aboutTitle: 'About Us',
    aboutSubtitle: 'Expert team dedicated to advancing Indonesian agriculture',
    visionTitle: 'Our Vision',
    visionText: 'To become the leading company in providing sustainable plant nutrition solutions',
    missionTitle: 'Our Mission',
    missionText: 'Providing high-quality products and best services to improve agricultural productivity',
    
    // Products section
    productsTitle: 'Featured Products',
    productsSubtitle: 'Complete nutrition solutions for various types of plants',
    productCategories: 'Product Categories',
    organicFertilizer: 'Organic Fertilizer',
    liquidFertilizer: 'Liquid Fertilizer',
    granularFertilizer: 'Granular Fertilizer',
    micronutrients: 'Micronutrients',
    
    // Blog section
    blogTitle: 'Agricultural Articles & Tips',
    blogSubtitle: 'Latest information about cultivation techniques and plant nutrition',
    latestArticles: 'Latest Articles',
    popularArticles: 'Popular Articles',
    categories: 'Categories',
    searchPlaceholder: 'Search articles...',
    publishedOn: 'Published on',
    writtenBy: 'Written by',
    
    // Testimonials
    testimonialTitle: 'Farmer Testimonials',
    testimonialSubtitle: 'Satisfaction and real results from farmers who have used our products',
    
    // Contact section
    contactTitle: 'Contact Us',
    contactSubtitle: 'Free consultation for your plant nutrition needs',
    nameLabel: 'Full Name',
    emailLabel: 'Email',
    phoneLabel: 'Phone Number',
    messageLabel: 'Message',
    sendMessage: 'Send Message',
    contactInfo: 'Contact Information',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    
    // Footer
    footerDescription: 'We are committed to providing the best plant nutrition solutions to improve agricultural productivity in Indonesia',
    quickLinks: 'Quick Links',
    followUs: 'Follow Us',
    allRightsReserved: 'All rights reserved',
    
    // Service section
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Complete solutions for modern agricultural needs',
    consultation: 'Expert Consultation',
    consultationDesc: 'Get advice from experienced plant nutrition experts',
    
    // Contact page
    viewOnMaps: 'View on Maps',
    businessHours: 'Business Hours',
    mondayFriday: 'Monday - Friday',
    saturday: 'Saturday',
    sundayHolidays: 'Sunday & Public Holidays',
    closed: 'Closed',
    contactNote: 'We are ready to serve you wholeheartedly. Contact us for free consultation!',
    soilTesting: 'Soil Testing',
    soilTestingDesc: 'Soil condition analysis for proper fertilizer recommendations',
    customFormula: 'Custom Formula',
    customFormulaDesc: 'Fertilizers with special formulations according to plant needs',
    
    // Advantages section
    advantagesTitle: 'Product Advantages',
    advantagesSubtitle: 'Why choose our products',
    quality: 'Guaranteed Quality',
    qualityDesc: 'High-quality products with international certification',
    organic: 'Environmentally Friendly',
    organicDesc: 'Organic formula that is safe for soil and environment',
    effective: 'Optimal Results',
    effectiveDesc: 'Proven to increase harvest yield up to 40%',
    support: 'Technical Support',
    supportDesc: 'Expert team ready to help with proper product application',
    
    // Portfolio/Projects
    portfolioTitle: 'Success Projects',
    portfolioSubtitle: 'Real results from implementing our products',
    projectDetail: 'Project Details',
    location: 'Location',
    cropType: 'Crop Type',
    area: 'Area',
    result: 'Result',
    
    // Error pages
    pageNotFound: 'Page Not Found',
    pageNotFoundDesc: 'Sorry, the page you are looking for could not be found',
    backToHomepage: 'Back to Homepage',
    
    // Portfolio/Product pages
    ourProducts: 'Our Products',
    productsDescription: 'Explore our premium fertilizer and plant nutrition products. Each product is specially formulated to ensure maximum plant growth, fertile soil, and abundant harvests. With our certified products, you are one step closer to sustainable agricultural success.',
    fertilizer: 'Fertilizer',
    plantNutrition: 'Plant Nutrition',
    others: 'Others',
    
    // Testimonials section
    testimonial: 'Testimonials',
    testimonialDesc: 'What clients say about our services and products.',
    
    // Call to action section
    readyForBestHarvest: 'Ready for the best harvest this year?',
    contactUs: 'Contact Us',
    achieveDreamHarvest: 'Let us make your dream of abundant harvest and successful farming come true!',
    
    // Blog CTA section
    needConsultation: 'Need Consultation?',
    consultationDescription: 'Our expert team is ready to help you choose the best fertilizer for abundant harvest and fertile soil.',
    contactUsButton: 'Contact Us',
    viewAllProducts: 'View All Products',
    
    // Blog error messages
    articleNotFound: 'Article Not Found',
    articleNotFoundDesc: 'Sorry, the article you are looking for could not be found.',
    backToBlog: 'Back to Blog',
    back: 'Back',
    
    // About/Team page
    aboutUsTitle: 'About Us',
    companyDescription: 'Bulindo Agro Technology is a company engaged in agricultural technology, designed to develop innovative technology capable of facing modern agricultural challenges at a global level.',
    fertilizerDescription: 'Our special fertilizers support the entire plant age by providing all the nutrients they need to grow healthier and stronger. Efficient plant nutrition combined with advanced technical services ensures strengthened plants and better resilience.',
    
    // Vision Mission
    visionMissionTitle: 'Vision & Mission',
    vision: 'Vision',
    mission: 'Mission',
    visionText2: 'To realize innovative, sustainable, and globally competitive agriculture through the application of smart technology to support food security and world ecosystem balance.',
    
    missionPoint1: 'Develop Smart Agricultural Technology',
    missionPoint1Desc: 'Bulindo Agro Technology is committed to developing innovative technology capable of facing modern agricultural challenges at a global level.',
    missionPoint2: 'Promote Sustainable Agricultural Practices',
    missionPoint2Desc: 'Implementing environmentally friendly methods that reduce negative impacts on soil, water, and air. Providing high-quality fertilizer products that are environmentally friendly and support natural resource conservation.',
    missionPoint3: 'Support Farmer Productivity',
    missionPoint3Desc: 'Delivering innovative fertilizer solutions that can increase crop yields and efficiency of resource use.',
    missionPoint4: 'Empower Farmers and Communities',
    missionPoint4Desc: 'Providing training and education to farmers on effective and sustainable fertilizer use for maximum results.',
    missionPoint5: 'Build Strong Partnerships',
    missionPoint5Desc: 'Collaborating with governments, organizations, and industry players to strengthen the fertilizer supply chain and expand positive impact on agriculture.',
    
    companyValues: 'Company Values',
    innovation: 'Innovation',
    innovationDesc: 'Continuously innovating in agricultural technology',
    qualityDesc2: 'Prioritizing the best product quality',
    sustainability: 'Sustainability',
    sustainabilityDesc: 'Committed to sustainable agriculture',
    
    // Contact form
    contactFormSubtitle: 'Let\'s start working together for better agricultural results! Fill out the form below, and we will get back to you within 24 hours.',
    yourName: 'Your Name',
    yourCompany: 'Your Company',
    yourEmail: 'Your Email',
    yourPhone: 'Your Phone Number',
    yourMessage: 'Leave your message here',
    send: 'Send',
    successMessage: 'Success! We\'ll get back to you soon. Thank you!',
    errorMessage: 'Please fill out the blank form.',
    
    // Project detail page
    projectNotFound: 'Product Not Found',
    goBack: 'Go Back',
    productDescription: 'Product Description',
    productType: 'Product Type',
    
    // Product descriptions
    turanDesc: 'Product based on EnNuvi Technology, Polyphenols, complexing nutrients to improve their performance so they can better protect plants from all types of stress.',
    colossalKDesc: 'We proudly introduce our latest product called Collosal-K, a high-quality potassium solution specifically designed for use as fertilizer. This product is very effective in preventing or correcting potassium deficiency that often becomes a problem in various types of plants.',
    foliarelDesc: 'To improve flower formation and fertility through better pollen viability, increasing high productivity fruit formation.',
    mantusDesc: 'Mantus with EnNuVi technology, a breakthrough in biostimulant technology as well as natural fertilizer, bioactivator, and food source for plants.',
    nixiDesc: 'Nixi with Foliflo technology creates a suspension formulated with bioactivation and complete nutrition to protect plant resilience.',
    primerDesc: 'A new, optimized, patented formulation containing Pico Technology derived from natural essential oils. This advanced formulation makes target organisms (e.g., insects) highly sensitive, allowing standard pesticide applications after Pangea Booster™ to kill even the most resistant pests by deactivating the metabolic pathway (cytochrome P-450) in the insects body.',
    adesivorDesc: 'Adesivor This is just sample text from the printing and typesetting industry.',
    defaultProductDesc: 'Product description will be available soon. Contact our team for more information about this product.',
    
    // Services content
    service1Title: 'Best Fertilizer and Plant Nutrition',
    service2Title: 'Agricultural Consultation',
    service3Title: 'Farmer and Community Empowerment',
    
    // Advantages content
    advantage1Title: 'High Quality Products',
    advantage1Desc: 'We provide high-quality fertilizer products designed to increase crop yields while maintaining ecosystem balance',
    advantage2Title: 'Affordable Prices',
    advantage2Desc: 'Committed to providing products at affordable prices as the best solution for farmers, agribusiness, and communities who care about the future of Indonesian agriculture',
    advantage3Title: 'Tested Products',
    advantage3Desc: 'Our products have been specially designed to meet the needs of various types of plants, and their quality has been tested.',
    advantage4Title: 'Farmers\' Favorite',
    advantage4Desc: 'Farmers have tried our products, and all our clients love them very much.',
    
    // Testimonials content
    testimonial1Name: 'Dadang',
    testimonial1Company: 'Farmer',
    testimonial1Text: 'I planted rice from the beginning of one week old using NIXI products. And, thank God, it\'s good, the tillers are also abundant, the leaves can also be wide, then the height is also maximum. It\'s good, in other words, it\'s good compared to other products that can guarantee the roots and tillers are also abundant.',
    testimonial2Name: 'Amin',
    testimonial2Company: 'Farmer',
    testimonial2Text: 'I have used Mantus, when applied at ten days and twenty days old. For Nixi three times you can see the results. Thank God, what I feel for Mantus is that the leaves can be thick, then above the leaves, the leaf roots can be thick, the leaves don\'t become limp.',
    testimonial3Name: 'Mamuri',
    testimonial3Company: 'Farmer',
    testimonial3Text: 'After I used Nixi and Mantus. The cell walls look thick but flexible. So when we want to water, we don\'t worry about the leaves breaking. The second advantage is that usually when we use nutrients, it can kill other pesticides. Well, after I tried using it, even though I mixed it directly with others, everything worked.',
  },
};

// Create context
const LanguageContext = createContext();

// Language provider component
export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('id'); // Default to Indonesian

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'id' ? 'en' : 'id'));
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    isIndonesian: language === 'id',
    isEnglish: language === 'en',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

// Custom hook to use language context
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
